import { useState, useEffect } from "react";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? "bg-white shadow-sm" : "bg-transparent"
      }`}
    >
      <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between">
        <h1 className="flex items-center m-0">
          <img
            src="https://aisprint.jp/assets/img/logo_header_ja.svg"
            alt="PRI AI Sprint"
            height={32}
            className="h-8"
          />
        </h1>
        <nav className="hidden md:flex items-center gap-8">
          <a
            href="/diagnostic/"
            className={`text-sm font-medium transition-colors hover:opacity-70 whitespace-nowrap ${
              scrolled ? "text-gray-700" : "text-white"
            }`}
          >
            最適プラン診断
          </a>
          <a
            href="#contact"
            className="bg-blue-600 text-white text-sm font-semibold px-5 py-2 rounded-full hover:bg-blue-700 transition-colors whitespace-nowrap"
          >
            無料モックを依頼
          </a>
        </nav>
        <button
          className="md:hidden w-8 h-8 flex items-center justify-center"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="メニュー"
        >
          <i className={`ri-${menuOpen ? "close" : "menu"}-line text-2xl ${scrolled ? "text-gray-800" : "text-white"}`}></i>
        </button>
      </div>
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 px-6 py-4 flex flex-col gap-4">
          <a href="/diagnostic/" className="text-sm font-medium text-gray-700 hover:text-blue-600 whitespace-nowrap">
            最適プラン診断
          </a>
          <a
            href="#contact"
            className="bg-blue-600 text-white text-sm font-semibold px-5 py-2 rounded-full text-center hover:bg-blue-700 transition-colors whitespace-nowrap"
          >
            無料モックを依頼
          </a>
        </div>
      )}
    </header>
  );
}
